// extracted by mini-css-extract-plugin
export default {"aboutHeader":"AboutHeader_aboutHeader__f-PrL"};